import {
  Typography,
  TypographyMods,
  TypographySizes,
} from '@vk-cloud-solutions/marketing-ui';
import classNames from 'classnames';
import Link from 'next/link';

import { CardDraftLabel } from '~components/CardDraftLabel/CardDraftLabel';
import { NextImage } from '~components/NextImage/NextImage';
import { NextImageMods } from '~components/NextImage/NextImage.types';

import styles from './ArticleCardBottomImage.module.scss';
import { ArticleCardBottomImageProps } from './ArticleCardBottomImage.types';

export function ArticleCardBottomImage({
  className,
  title,
  categories,
  href,
  publishedAt,
  image,
  imageWithBg,
}: ArticleCardBottomImageProps) {
  return (
    <article className={classNames(className, styles.card)}>
      {!publishedAt && <CardDraftLabel />}
      <div className={styles.content}>
        <div className={styles.top}>
          {categories?.map((category) => (
            <Typography
              tagName={TypographySizes.div}
              mods={[TypographyMods.bodySAlt]}
              className={styles.category}
              key={category.id}
            >
              {category.title}
            </Typography>
          ))}
        </div>

        <Typography
          tagName={TypographySizes.h3}
          className={styles.title}
          mods={[TypographyMods.titleL]}
        >
          {title}
        </Typography>
      </div>
      {image && (
        <div className={styles.media}>
          <NextImage
            className={styles.image}
            {...image}
            mods={!imageWithBg ? [NextImageMods.FitContain] : []}
          />
        </div>
      )}
      <div>
        <Link className={styles.link} href={href} />
      </div>
    </article>
  );
}
